Vue.component('bar-chart', {
    props: ['chart-data'],

    mounted () {
        let data = {
            labels: [],
            data: []
        };

        for (let y in this.chartData) {
            data.labels.push(this.chartData[y][0]);
            data.data.push(Number(this.chartData[y][1]));
        }

        new Chart($(this.$el).find('canvas'), {
            type: 'bar',
            responsive: true,
            data: {
                labels: data.labels,
                datasets: [{
                    backgroundColor: 'rgba(220, 220, 220, 0.5)',
                    borderColor: 'rgba(220, 220, 220, 0.8)',
                    highlightFill: 'rgba(220, 220, 220, 0.75)',
                    highlightStroke: 'rgba(220, 220, 220, 1)',
                    data: data.data
                }]
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                },
                responsive: true
            }
        });
    },

    template: `<div style="position: relative;"><canvas></canvas></div>`
});